var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudent37(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M876.999+915.886L183.402+915.886C165.861+915.886+152.367+901.685+153.262+884.167L167.853+598.697C167.853+527.055+232.424+483.214+281.359+478.515L413.788+469.661L622.622+469.234L747.281+478.515C808.61+483.214+860.787+527.055+860.787+598.697L876.999+915.886Z",
    opacity: 1,
    fill: "#7381ec"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#f4d1bd",
    d: "M511.722+110.569L519.278+110.569C617.868+110.569+697.791+196.81+697.791+303.194L697.791+303.194C697.791+409.578+617.868+495.819+519.278+495.819L511.722+495.819C413.131+495.819+333.208+409.578+333.208+303.194L333.208+303.194C333.208+196.81+413.131+110.569+511.722+110.569Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.641+350.256L518.054+350.256C575.632+350.256+622.309+400.324+622.309+462.085L622.309+462.085C622.309+523.847+575.632+573.914+518.054+573.914L513.641+573.914C456.062+573.914+409.386+523.847+409.386+462.085L409.386+462.085C409.386+400.324+456.062+350.256+513.641+350.256Z",
    opacity: 1,
    fill: "#f4d1bd"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    d: "M631.705+113.615C631.705+113.615+621.687+102.941+636.201+86.6406C655.51+64.9527+710.133+54.2171+735.164+116.34C741.225+131.381+745.968+150.195+753.312+185.95C758.49+211.16+760.852+240.28+760.444+276.333C760.037+312.387+729.44+499.779+713.04+497.409C696.64+495.038+720.571+392.141+707.144+282.159C703.121+249.202+706.296+250.381+687.968+210.936C666.936+165.674+631.705+113.615+631.705+113.615Z",
    fill: "#383738"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 1,
    fill: "#383738",
    d: "M411.572+112.835C411.572+112.835+422.667+103.287+409.969+85.5357C393.073+61.9185+339.9+45.4387+308.409+104.55C300.784+118.862+294.068+137.065+282.966+171.837C275.138+196.354+269.695+225.058+266.269+260.95C262.843+296.843+273.352+486.426+289.91+485.812C306.469+485.197+293.609+380.339+318.648+272.408C326.151+240.065+322.869+240.899+345.285+203.626C371.008+160.856+411.572+112.835+411.572+112.835Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M614.974+105.449L614.974+105.449C620.608+102.466+627.92+104.488+631.305+109.965L680.705+189.886C684.091+195.363+682.268+202.221+676.634+205.204L676.634+205.204C671+208.187+663.688+206.165+660.303+200.688L610.903+120.767C607.517+115.29+609.34+108.432+614.974+105.449Z",
    opacity: 1,
    fill: "#7381ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.087+106.281L427.087+106.281C421.802+102.716+414.317+103.949+410.369+109.036L352.755+183.254C348.807+188.34+349.89+195.354+355.175+198.918L355.175+198.918C360.46+202.483+367.945+201.25+371.894+196.164L429.508+121.945C433.456+116.859+432.372+109.846+427.087+106.281Z",
    opacity: 1,
    fill: "#7381ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.21+89.9298C521.057+89.4343+538.719+91.5648+538.719+91.5648C675.868+95.6521+751.427+344.064+678.711+418.406C678.711+418.406+668.182+166.829+515+163.559C361.818+160.289+355.342+418.406+355.342+418.406C256.106+343.209+365.248+94.0172+504.21+89.9298Z",
    fill: "#383738",
    opacity: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent37);
export default __webpack_public_path__ + "static/media/Student 37.6f5d2f8507d3043bb26ea7528fca86f4.svg";
export { ForwardRef as ReactComponent };